var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_companyinfo"},[_c('div',{staticClass:"head"},[_c('span',{staticClass:"title"},[_vm._v("单位图片")]),_vm._v(" "),_c('div',{staticClass:"pic-list"},[_c('viewer',{attrs:{"images":_vm.pics}},[_vm._l((_vm.pics),function(pic){return [_c('div',{staticClass:"one-pic"},[_c('img',{attrs:{"src":pic.url}})])]})],2)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-390f7582","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/baseinfo/business/Pictures.vue
// module id = null
// module chunks = 